/**
 * This is a custom modal which will have no backdrop on desktop and have on mobile
 * On mobile the modal body comes from the bottom
 */
import React, { useEffect } from 'react';
import './style.scss';

const CustomModal = (props) => {
  const closeModal = (e) => {
    e.stopPropagation();
    // Check if the clicked element is the overlay itself
    if (e.target.classList.contains('custom-modal-overlay')) {
      props.onClose(e);
    }
  };

  useEffect(() => {
    if (props?.preventBodyScroll) {
      if (props?.open) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'visible';
      }
      return () => {
        document.body.style.overflow = 'visible';
      };
    }
  }, [props?.open]);

  return (
    props.open && (
      <>
        <div className={`custom-modal-overlay`} onClick={closeModal}>
          <div
            className={`${props.customClass} custom-modal-body bg-white ${props.open ? 'show' : ''}`}>
            {props.children}
          </div>
        </div>
      </>
    )
  );
};

export default CustomModal;
